const SPOTLIGHT_PARENT_SLIDEBAR_SELECTOR = '.c-slidebar';
export { SPOTLIGHT_PARENT_SLIDEBAR_SELECTOR, };
//# sourceMappingURL=spotlight-constants.js.map